import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Prefix = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-a8l2f9-0"
})(["font:", ";flex:0 0 auto;box-sizing:border-box;white-space:nowrap;display:flex;align-items:center;padding:unset;background:transparent;color:", ";/*! @noflip */ border-radius:", ";", " ", " padding-inline-start:", ";padding-block:", ";", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => `${theme.border.radius.medium} 0 0 ${theme.border.radius.medium}`, ({
  $ignoreTextDirection
}) => !$ignoreTextDirection && css(["/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ border-radius:", ";}"], ({
  theme
}) => `0 ${theme.border.radius.medium} ${theme.border.radius.medium} 0`), ({
  $disabled
}) => $disabled && css(["cursor:not-allowed;outline:none;opacity:1;background-color:", ";color:", ";"], ({
  theme
}) => theme.input.backgroundColor.unavailable, ({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.controls.paddingInline.large.default, ({
  theme
}) => theme.controls.paddingBlock.base.default, isMobile(css(["font:", ";padding-inline-start:", ";padding-block:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.controls.paddingInline.large.mobile, ({
  theme
}) => theme.controls.paddingBlock.base.mobile)));

export { Prefix as P };
//# sourceMappingURL=Prefix-DtU_bcjb.js.map
